<template>
    <div :ref="`filter-tag-${filter.code}`" class="listing-table-filters__container">
        <CompassDatePicker
            v-bind="filter.filterConfig"
            ref="datepicker"
            :modelValue="filter.datePickerValues"
            :openCalendar="filter.displayDropdown"
            @close="updateVisibility(false)"
            @update:modelValue="updateFilter"
            @shortcutClicked="handleShortcutClick"
        >
            <ListingTableFiltersTag
                ref="datepickerTrigger"
                :type="filter.code"
                :label="filter.activeLabel"
                :valuesHumanized="filter.filterConfig.range ? labelTagRange : labelTagSingle"
                @removeFilter="removeFilter"
            />
        </CompassDatePicker>
    </div>
</template>
<script>
import ListingTableFiltersTag from 'vcomponents/common/listing/filters/ListingTableFiltersTag.vue';
import ListingTableFilter from 'vcomponents/common/listing/filters/ListingTableFilter.vue';
import { retrieveShortcutFromId } from 'Helpers/activities/activitiesDateFilters.js';
import { isEqual } from 'lodash';

export default {
    components: { ListingTableFiltersTag },
    extends: ListingTableFilter,
    emits: ['update:displayDropdown', 'updateFilter', 'updateFilterOptions', 'removeFilter'],
    data() {
        return {
            shortcutSelected: null,
        };
    },
    computed: {
        labelTagSingle() {
            if (!this.filter.optionsSelected) {
                return '';
            }
            if (this.shortcutSelected?.id) {
                return this.shortcutSelected.label;
            }
            return this.$filters.dateFormatter(
                moment(this.filter.datePickerValues).unix(),
                'SLASHED_DATE',
                false,
            );
        },
        labelTagRange() {
            if (
                !this.filter.optionsSelected ||
                (this.filter.optionsSelected === 'customRange' &&
                    this.filter.datePickerValues.length !== 2)
            ) {
                return '';
            }
            if (this.shortcutSelected?.id) {
                return this.shortcutSelected.label;
            }
            const start = this.$filters.dateFormatter(
                moment(this.filter.datePickerValues[0]).unix(),
                'SLASHED_DATE',
                false,
            );
            const end = this.$filters.dateFormatter(
                moment(this.filter.datePickerValues[1]).unix(),
                'SLASHED_DATE',
                false,
            );
            return `${start} - ${end}`;
        },
    },
    watch: {
        'filter.displayDropdown': {
            handler(displayDropdown) {
                if (displayDropdown) {
                    this.$refs.datepickerTrigger?.$el.click();
                }
            },
        },
    },
    created() {
        if (this.filter.optionsSelected && this.filter.optionsSelected !== 'customRange') {
            const shortcut = retrieveShortcutFromId(this.filter.optionsSelected);
            this.shortcutSelected = { id: shortcut.id, label: shortcut.label };
        }
    },
    methods: {
        handleShortcutClick(value) {
            this.shortcutSelected = value;
            this.$emit('updateFilterOptions', value.id);
        },
        updateFilter(values) {
            if (isEqual(values, this.filter.datePickerValues)) {
                return;
            }
            const valuesShortcut = retrieveShortcutFromId(this.shortcutSelected?.id)?.action();
            if (valuesShortcut !== values) {
                this.shortcutSelected = null;
            }
            const option = this.shortcutSelected?.id ?? 'customRange';

            this.$emit('updateFilter', { values, option });
            this.updateVisibility(false);
        },
        removeFilter() {
            this.$emit('removeFilter', this.filter.code);
        },
        updateVisibility(value) {
            this.$emit('update:displayDropdown', value);
        },
    },
};
</script>
